import React from 'react';
import { Footnote } from '@qover/typography';
import CheckmarkIcon from '@qover/icons/Checkmark';
import AmericanExpressIcon from '@qover/icons/AmericanExpressIcon';
import BancontactIcon from '@qover/icons/BancontactIcon';
import MastercardIcon from '@qover/icons/MastercardIcon';
import VisaIcon from '@qover/icons/VisaIcon';
import messages from './includeInPack.messages';
import {
  CardContainer,
  Content,
  IconContainer,
  Message,
  Row,
} from './includeInPack.styles';

const inclusions = ({ showBancontact }: { showBancontact?: boolean }) => {
  const payments = [VisaIcon, MastercardIcon, AmericanExpressIcon];

  if (showBancontact) {
    payments.push(BancontactIcon);
  }

  return [
    {
      message: messages.bonus2,
      infos: payments.map((PaymentCard, idx) => (
        <CardContainer key={idx}>
          <PaymentCard />
        </CardContainer>
      )),
    },
    {
      message: messages.bonus1,
    },
    {
      message: messages.bonus3,
    },
  ];
};

type IncludeInPackProps = {
  showBancontact?: boolean;
};

export function IncludeInPack(props: IncludeInPackProps) {
  return (
    <Content>
      {inclusions({ showBancontact: props.showBancontact }).map(
        (inclusion, idx) => (
          <Message key={idx}>
            <IconContainer>
              <CheckmarkIcon />
            </IconContainer>
            <Footnote className="bold">{inclusion.message}</Footnote>
            {inclusion.infos && <Row className="spaced">{inclusion.infos}</Row>}
          </Message>
        ),
      )}
    </Content>
  );
}
